// extracted by mini-css-extract-plugin
export default {"thanksPage":"thanks_thanksPage__+pGKb","thanksCard":"thanks_thanksCard__hrrED","thanksIcon":"thanks_thanksIcon__1DLwM"};